import { SvgIcon } from "@mui/material";
import React from "react";

const AdminEcommerce = (props) => {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path d="M22.5,10h-4L12.73,2.3a.77.77,0,0,0-.6-.3h-.26a.77.77,0,0,0-.6.3L5.5,10h-4a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H2l1.71,7.65A3,3,0,0,0,6.6,22H17.4a3,3,0,0,0,2.92-2.35L22,12h.47a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,22.5,10ZM12,4.67,16,10H8Zm6.37,14.55a1,1,0,0,1-1,.78H6.6a1,1,0,0,1-1-.78L4,12H20Z" />
    </SvgIcon>
  );
};

export default AdminEcommerce;
